import { css } from '@emotion/react'
import { Link } from '../base-ui'
import { FiArrowUpRight } from 'react-icons/fi'

function LinkItem({ children, href }) {
    if(!href) return null
    const style = css`
        padding: 0.5rem;
        border-bottom: 1px dashed #cccccc;
    `
    const linkStyle = `
        display: block;
        width: 100%;
        a {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
        }
        .internal-link {
            width: 100%;
        }
       
    `

    return (
        <div css={style}>
            <Link href={href} style={linkStyle}>
                {children}
                <FiArrowUpRight />
            </Link>
        </div>
    )
}

export default LinkItem
